class RowProductsScrollbar extends HTMLElement {
  connectedCallback() {
    this.viewport = this.querySelector('[data-row-products-viewport]');
    this.scrollbar = this.querySelector('[data-row-products-scrollbar]');
    this.track = this.querySelector('[data-row-products-track]');
    this.thumb = this.querySelector('[data-row-products-thumb]');

    if (!this.viewport || !this.scrollbar || !this.track || !this.thumb) return;

    this.onScroll = this.update.bind(this);
    this.viewport.addEventListener('scroll', this.onScroll, { passive: true });

    this.resizeObserver = new ResizeObserver(() => this.update());
    this.resizeObserver.observe(this.viewport);

    this.isDown = false;
    this.dragged = false;
    this.startX = 0;
    this.startScrollLeft = 0;

    this.onPointerDown = this.onPointerDown.bind(this);
    this.onPointerMove = this.onPointerMove.bind(this);
    this.onPointerUp = this.onPointerUp.bind(this);
    this.onClickCapture = this.onClickCapture.bind(this);
    this.onDragStart = this.onDragStart.bind(this);

    this.viewport.addEventListener('pointerdown', this.onPointerDown);
    this.viewport.addEventListener('pointermove', this.onPointerMove);
    this.viewport.addEventListener('pointerup', this.onPointerUp);
    this.viewport.addEventListener('pointercancel', this.onPointerUp);
    this.viewport.addEventListener('click', this.onClickCapture, true);
    this.viewport.addEventListener('dragstart', this.onDragStart);

    this.update();
  }

  disconnectedCallback() {
    this.viewport?.removeEventListener('scroll', this.onScroll);
    this.resizeObserver?.disconnect();

    this.viewport?.removeEventListener('pointerdown', this.onPointerDown);
    this.viewport?.removeEventListener('pointermove', this.onPointerMove);
    this.viewport?.removeEventListener('pointerup', this.onPointerUp);
    this.viewport?.removeEventListener('pointercancel', this.onPointerUp);
    this.viewport?.removeEventListener('click', this.onClickCapture, true);
    this.viewport?.removeEventListener('dragstart', this.onDragStart);
  }

  onDragStart(event) {
    event.preventDefault();
  }

  onPointerDown(event) {
    if (event.pointerType === 'touch') return;
    if (event.button !== 0) return;

    this.isDown = true;
    this.dragged = false;
    this.pointerId = event.pointerId;
    this.startX = event.clientX;
    this.startScrollLeft = this.viewport.scrollLeft;
  }

  onPointerMove(event) {
    if (!this.isDown) return;

    const delta = event.clientX - this.startX;

    if (!this.dragged && Math.abs(delta) > 3) {
      this.dragged = true;
      // Capturing on pointerdown would retarget the resulting click to the viewport, breaking links.
      this.viewport.setPointerCapture(this.pointerId);
      this.viewport.classList.add('row-products__list--dragging');
    }

    if (!this.dragged) return;

    this.viewport.scrollLeft = this.startScrollLeft - delta;
  }

  onPointerUp(event) {
    if (!this.isDown) return;

    this.isDown = false;

    if (this.dragged) {
      this.viewport.releasePointerCapture(this.pointerId);
      this.viewport.classList.remove('row-products__list--dragging');
    }
  }

  onClickCapture(event) {
    if (this.dragged) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  update() {
    const { viewport, scrollbar, thumb } = this;
    const scrollWidth = viewport.scrollWidth;
    const clientWidth = viewport.clientWidth;

    if (scrollWidth <= clientWidth + 1) {
      scrollbar.hidden = true;
      return;
    }

    scrollbar.hidden = false;

    const rawRatio = (viewport.scrollLeft + clientWidth) / scrollWidth;
    const ratio = Math.min(1, Math.max(0, rawRatio));

    thumb.style.width = `${ratio * 100}%`;
  }
}

customElements.define('row-products-scrollbar', RowProductsScrollbar);

function initRowProductsVisibility(root) {
  root.querySelectorAll('[data-row-products-section]').forEach((section) => {
    if (section.dataset.rowProductsVisibilityBound) return;
    section.dataset.rowProductsVisibilityBound = 'true';

    const update = () => {
      section.hidden = !section.querySelector('.row-products__item');
    };

    update();
    new MutationObserver(update).observe(section, { childList: true, subtree: true });
  });
}

document.addEventListener('DOMContentLoaded', () => initRowProductsVisibility(document));
